<template>
	<div :class="{ snote: !integrated }">
		<div class="note"></div>
	</div>
</template>

<script>
require("summernote/dist/summernote.css");
import $ from "jquery";
import sn from "summernote";
import _ from "lodash";

export default {
	name: "RichText",
	props: {
		initial: { type: String, default: "" },
		options: {
			type: Object,
			default: () => {
				return {};
			},
		},
		text: { type: String, default: "" },
		initSettings: {
			type: Object,
			default: () => {
				return {};
			},
		},
		refresh: { type: String, default: "" },
		integrated: { type: Boolean, default: false },
	},
	data() {
		var defaults = {
			toolbar: [
				["style", ["bold", "italic", "underline", "strikethrough", "clear"]],
				["fontsize", ["fontsize"]],
				["para", ["ul", "ol", "paragraph"]],
				["meta", ["undo", "redo"]],
				["insert", ["picture", "link"]],
			],
			height: 300,
			placeholder: "Write message here...",
			dialogsInBody: true,
		};
		return {
			mut_text: _.cloneDeep(this.text),
			mut_opts: _.extend(defaults, this.options),
		};
	},
	mounted() {
		console.log(sn);
		this.initialize(this.initial);
	},

	watch: {
		initial() {
			this.loadInitial();
		},
		refresh() {
			this.loadInitial();
		},
	},

	destroyed() {
		this.destroy();
	},

	methods: {
		loadInitial() {
			var el = $(this.$el).find(".note");
			el.summernote("code", this.initial);
		},

		changed(we, contents) {
			this.$emit("update:text", contents);
		},

		destroy() {
			$(this.$el).find("note").summernote("destroy");
		},

		initialize() {
			var el = $(this.$el).find(".note");
			el.summernote(this.mut_opts);
			el.on("summernote.change", this.changed);
			if (this.initial) {
				el.summernote("code", this.initial);
			} else if (this.initSettings) {
				_.each(this.initSettings, (value, setting) => {
					el.summernote(setting, value);
				});
			}
			// this.defaults.toolbar.append(["insert", ["picture", "link"]])
		},
	},
};
</script>

<style scoped>
.snote {
	background-color: white;
	margin-bottom: 20px;
	text-align: left;
}
.dropdown-menu {
	color: initial;
	font-size: initial;
}
</style>
